export default ($axios) => ({
  fetchTabs(query) {
    return $axios.get('/omni/tabs', { params: query }).then((response) => response.data);
  },
});
